<div class="liberro-explain-box" [class.warning]="variant === 'warning'">
  <div class="liberro-explain-box__header">
    @if (icon) {
      <svg-icon
        [src]="'assets/icons/' + icon"
        class="liberro-explain-box__icon"
      ></svg-icon>
    }
    <p class="liberro-explain-box__title">{{ title }}</p>
  </div>
  <div class="liberro-explain-box__content">
    <ng-content></ng-content>
  </div>
</div>

